module.exports = __webpack_public_path__ + "img/edit-bookmark-dashboard.c3e41dcd.png";